import gql from 'graphql-tag';
import {basePageableGraphqlField, responseField} from "../../../../base.graphql";



export const currencyFields = `
id
uuid
title
shortForm
`;


export const CREATE_CURRENCY_EDUCATION_LEVEL = gql`
mutation CreateCurrencyType($input: CurrencyInput!) {
  createCurrencyType(input: $input) {
    response {
      ${responseField}
    }
    data {
      ${currencyFields}
    }
  }
}
`


export const UPDATE_CURRENCY_EDUCATION_LEVEL = gql`
mutation UpdateCurrencyType($input: CurrencyInput!) {
  updateCurrencyType(input: $input) {
    response {
      ${responseField}
    }
    data {
      ${currencyFields}
    }
  }
}
`


export const GET_CURRENCIES = gql`
query GetAllCurrencies($inputFilter: CurrencyFilteringInput) {
  getAllCurrencies(filtering: $inputFilter) {
    response {
      ${responseField}
    }
    page {
      ${basePageableGraphqlField}
    }
    data {
      ${currencyFields}
    }
  }
}
`


export const GET_EDUCATION_LEVELS = gql`
query GetAllEducationLevels($inputFilter: CurrencyFilteringInput) {
  getAllEducationLevels(filtering: $inputFilter) {
    response {
      ${responseField}
    }
    page {
      ${basePageableGraphqlField}
    }
    data {
      ${currencyFields}
    }
  }
}
`


export const DELETE_CURRENCY = gql`
mutation DeleteCurrencyType($uuid: String!) {
  deleteCurrencyType(uuid: $uuid) {
    response {
      ${responseField}
    }
  }
}
`
